import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const WhoShouldAttendNewSection: React.FC = () => {
  const attendees = [
    "Salon Owners",
    "Spa Owners", 
    "Tattoo Studio Owners",
    "Nail Studio Owners",
    "Beauty & Wellness Managers"
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-black mb-6 leading-tight">
            Who Should <span className="text-red-500">Attend?</span>
          </h2>
          <div className="w-32 h-1 bg-red-500 mx-auto rounded-full"></div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="space-y-6"
        >
          {/* First Row - 3 items */}
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 md:gap-12 lg:gap-16">
            {attendees.slice(0, 3).map((attendee, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                viewport={{ once: true }}
                className="flex items-center space-x-2 sm:space-x-3 group"
              >
                <div className="bg-red-500 rounded-full p-1.5 sm:p-2 shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-white" />
                </div>
                <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-black group-hover:text-red-600 transition-colors duration-300">
                  {attendee}
                </span>
              </motion.div>
            ))}
          </div>

          {/* Second Row - 2 items */}
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 md:gap-12 lg:gap-16">
            {attendees.slice(3, 5).map((attendee, index) => (
              <motion.div
                key={index + 3}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.6 + index * 0.1 }}
                viewport={{ once: true }}
                className="flex items-center space-x-2 sm:space-x-3 group"
              >
                <div className="bg-red-500 rounded-full p-1.5 sm:p-2 shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-white" />
                </div>
                <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-black group-hover:text-red-600 transition-colors duration-300">
                  {attendee}
                </span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhoShouldAttendNewSection;
